import { trpc } from '@/client/utils/trpc';
import type { RouterOutputs } from '@/client/utils/trpc';

type Employee = RouterOutputs['employees']['list'][number];

function StatCard({ label, value }: { label: string; value: string | number }) {
  return (
    <div className="rounded-lg border bg-card p-4">
      <p className="text-xs text-muted-foreground">{label}</p>
      <div className="tnum mt-1 text-2xl font-semibold">{value}</div>
    </div>
  );
}

interface PersonStatCardsProps {
  person: Employee;
}

export function PersonStatCards({ person }: PersonStatCardsProps) {
  const now = new Date();
  const monthName = now.toLocaleString('default', { month: 'long' });

  const { data: hoursData } = trpc.employees.getHoursThisMonth.useQuery(
    { id: person.id },
    { enabled: !!person.id },
  );

  const rateLabel = person.rate != null ? `${person.rate} / ${person.rate_type ?? '?'}` : '—';

  const joinedDate = new Date(person.created_at).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

  return (
    <div className="mb-6 grid grid-cols-4 gap-3">
      <StatCard label="Rate" value={rateLabel} />
      <StatCard
        label={`Hours · ${monthName}`}
        value={hoursData != null ? `${hoursData.total_hours}h` : '—'}
      />
      <StatCard label="Projects" value={person.project_count} />
      <StatCard label="Joined" value={joinedDate} />
    </div>
  );
}
